/* istanbul ignore file */
import { css } from 'styled-components';

export const iconDisabled = css`
  filter: opacity(50%);
`;
